import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (import.meta.env.VITE_NODE_ENV === "production" && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [
      /^\//,
      /^https:\/\/api-prod\.invozio\.com/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // 👇 Corrected beforeSend with `hint`
    beforeSend(event, hint) {
      const exception = event.exception?.values?.find(
        (ex) =>
          ex.type === "SyntaxError" &&
          ex.value?.includes("Invalid or unexpected token") &&
          ex.stacktrace?.frames?.some((frame) =>
            frame.abs_path?.includes("trustpilot.com")
          )
      );

      if (exception) {
        return null;
      }

      const originalException = hint?.originalException;
      if (originalException && !(originalException instanceof Error)) {
        return null;
      }

      return event;
    },
  });
}
